// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"AnchorNav_noScrolling__ffKoa","nav":"AnchorNav_nav__UnhpN","active":"AnchorNav_active__C8Dq3","navLink":"AnchorNav_navLink__cyApK"};